<script lang="ts" setup>
import { computed } from 'vue';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

const { content } = defineProps<{ content: string }>();

const html = computed(() => {
  const dirty = marked.parse(content || '', {
    async: false,
  });
  return DOMPurify.sanitize(dirty);
});
</script>

<template>
  <div v-html="html" />
</template>
